import { useEffect, useRef } from 'react';
import { btnGhost, btnPrimary } from './styles';
import type { LeaveDialogProps as Props } from '../../contexts/UnsavedWorkContext';

/**
 * "Je hebt niet-opgeslagen wijzigingen. Weggaan?" Een native modale dialog: focus blijft erin,
 * Escape = blijven. De veilige keuze (blijven) heeft de focus.
 */
export function LeaveConfirmDialog({
  open,
  onStay,
  onLeave
}: Props) {
  const ref = useRef<HTMLDialogElement>(null);
  const stayRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) {
      d.showModal();
      stayRef.current?.focus();
    } else if (!open && d.open) d.close();
  }, [open]);
  return <dialog ref={ref} aria-labelledby="leave-title" aria-describedby="leave-text" onCancel={e => {
    e.preventDefault();
    onStay();
  }} className="w-[min(26rem,calc(100vw-2rem))] rounded-lg border border-line bg-shell p-0 text-ink shadow-xl backdrop:bg-ink/40" data-id="element-5270" data-mp="14ps5wn6f3njd">
      <div className="p-5" data-id="element-5271" data-mp="tj7cgesxmc90">
        <h2 id="leave-title" className="text-[16px] font-medium text-ink" data-id="element-5272" data-mp="tifgh2vfaci7">
          Je hebt niet-opgeslagen wijzigingen. Weggaan?
        </h2>
        <p id="leave-text" className="mt-2 text-[14px] text-muted" data-id="element-5273" data-mp="137paio9tu58y">
          Als je weggaat, ben je wat je niet hebt opgeslagen kwijt.
        </p>
        <div className="mt-5 flex flex-wrap justify-end gap-2" data-id="element-5274" data-mp="yfo25dfs4yo7">
          <button type="button" onClick={onLeave} className={btnGhost} data-id="element-5275" data-mp="1c7ugqv3aaxlj">
            Weggaan
          </button>
          <button ref={stayRef} type="button" onClick={onStay} className={btnPrimary} data-id="element-5276" data-mp="178ix9ebj9e09">
            Blijven
          </button>
        </div>
      </div>
    </dialog>;
}